import { getApiHost } from "@/stores/useEnvConfigStore";
import useLayoutStore from "@/stores/useLayoutStore";
import useToastStore from "@/stores/useToastStore";
import isOnline from "is-online";
import wretch from "wretch";
import AbortAddon from "wretch/addons/abort";
import FormDataAddon from "wretch/addons/formData";
import QueryStringAddon from "wretch/addons/queryString";
import authTokenMiddleware from "./middlewares/authTokenMiddleware";
import endpointMiddleware from "./middlewares/endpointMiddleware";
import hashMiddleware from "./middlewares/hashMiddleware";
import localeMiddleware from "./middlewares/localeMiddleware";
import sidMiddleware from "./middlewares/sidMiddleware";
import traceMiddleware from "./middlewares/traceMiddleware";
import { openModal } from "@/stores/useModalStore";

const apiHost = getApiHost();

const wretcher = wretch(apiHost, { cache: "default" })
  .addon(FormDataAddon)
  .addon(QueryStringAddon)
  .addon(AbortAddon())
  .accept("text/plain")
  .middlewares([
    endpointMiddleware,
    authTokenMiddleware,
    localeMiddleware,
    sidMiddleware,
    traceMiddleware,
    hashMiddleware,
  ])
  .catcher(401, (e) => {
    console.error("auth error", e);
    openModal("sign-in");
    useLayoutStore.getState().setShouldSignOut(true);

    return false;
  })
  .catcherFallback(async (e) => {
    if (e.name === "AbortError") {
      return;
    }
    console.error("[Wretch] fallback error:", e);

    let message = "";
    if (e.status) {
      message = `[${e.status}] ${e.message}`;
    } else {
      const online = await isOnline();

      message = online ? 't("ERROR.600005")' : 't("ERROR.600004")';
    }

    useToastStore.getState().show({
      type: "error",
      message,
    });
  });

export default wretcher;
